import { tvpil } from '../compat/tvpil';
import { createUserUnauthorizedError } from '../errors';
import { fetchFavoriteChannelsQuery } from '../favorite/queries';
import { fetchLastWatchedQuery } from '../lastWatched/fetchLastWatchedQuery';
import { createLastWatched } from '../lastWatched/utils';
import { fetchMostWatchedQuery } from '../mostWatched/fetchMostWatchedQuery';
import { createMostWatched } from '../mostWatched/utils';

import { composeChannels } from './composeChannels';
import { fetchChannelCollectionQuery, fetchEntitledChannelsQuery, fetchChannelsQuery } from './queries';
import { getLimit } from './utils';

export type FetchChannelsArgs = {
  referenceId: string;
  pageReferenceId?: string;
};

export async function fetchChannels({ referenceId, pageReferenceId }: FetchChannelsArgs) {
  if (!tvpil.userId) {
    throw createUserUnauthorizedError();
  }

  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return undefined;
  }

  const [
    channelAssetsData,
    entitledChannelsData,
    channelCollectionData,
    favoriteChannelsData,
    lastWatchedMapData,
    watchStats,
  ] = await Promise.all([
    fetchChannelsQuery(),
    fetchEntitledChannelsQuery(),
    fetchChannelCollectionQuery({ referenceId }),
    fetchFavoriteChannelsQuery(),
    fetchLastWatchedQuery(),
    fetchMostWatchedQuery(tvpil.userId),
  ]);

  if (!channelCollectionData) {
    return undefined;
  }

  const lastWatchedData = pageReferenceId
    ? createLastWatched({
        defaultChannelId: category.railProperty.defaultChannel,
        lastWatchedData: lastWatchedMapData,
        pageReferenceId,
      })
    : undefined;

  const mostWatchedData = createMostWatched({
    mostWatched: category.mostWatched,
    watchStats,
  });

  return composeChannels({
    channelAssetsMap: channelAssetsData.channelMap,
    channelCollection: channelCollectionData.collection,
    entitledChannels: entitledChannelsData,
    favoriteChannels: favoriteChannelsData.favoritePositions,
    lastWatched: lastWatchedData,
    limit: getLimit(category),
    mostWatched: mostWatchedData,
    orderBatches: category.epgProperty?.orderBatches,
  });
}
